<a (click)="toggle()" [ngClass]="{'active' : layout.sidebar}"><i class="fas fa-bars"></i></a>
<h1>{{layout.title}}</h1>
